import { IRequestConfig } from "models/Axios";
import Services from "./index.service";
//generics
import qs from "qs";


export default class ManagementPanelService extends Services<any, any> {
  public getTotalQuotations = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/TotalQuotations`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getAnsweredQuotations = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/AnsweredQuotations`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getReviewRate = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/ReviewRate`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getReviewRateBySeller = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/ReviewRateBySeller`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getChangeRatePercentage = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/ChangeRatePercentage`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getTotalQuotationsWithoutMapping = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/TotalQuotationsWithoutMapping`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getTotalUnansweredItems = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/TotalUnansweredItems`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getTotalAnsweredItems = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/TotalAnsweredItems`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getTemporalEvolution = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/TemporalEvolution`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getQuotationsByUnansweredItems = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/GetQuotationsByUnansweredItems`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getQuotationsByAnsweredItems = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/GetQuotationsByAnsweredItems`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getQuotationsByItemsWithoutMapping = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/GetQuotationsByItemsWithoutMapping`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getChangeRateBySeller = (filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/ChangeRateBySeller`,
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getDataInsightsRAItemsByStatus = (status?: number, filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/indicator/DataInsightsRAItemsByStatus`,
      params: { ...filter, ...(status !== undefined ? { status } : {}) },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };

  public getDataInsightsRAItemsDetailsByStatus = (status: number, filter?: any) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/DataInsightsRAItemsDetailsByStatus`,
      params: { ...filter, status },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };
    return this.httpRequest(config);
  };
}